'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import MovieCard, { Movie } from '@/components/ui/MovieCard';
import Icon from '@/components/ui/AppIcon';

const allMovies: Movie[] = [
{ id: 'disc-001', title: 'Dune: Part Two', year: 2024, genre: ['Sci-Fi', 'Adventure'], rating: 4.6, reviewCount: 14820, poster: "https://images.unsplash.com/photo-1573106341805-7db29def6c9d", posterAlt: 'Desert landscape with dramatic orange sky', badge: 'trending', runtime: 166 },
{ id: 'disc-002', title: 'Oppenheimer', year: 2023, genre: ['Drama', 'History', 'Thriller'], rating: 4.8, reviewCount: 22340, poster: "https://img.rocket.new/generatedImages/rocket_gen_img_105051ad8-1785350644691.png", posterAlt: 'Abstract light patterns from nuclear reaction', badge: 'top-rated', runtime: 180 },
{ id: 'disc-003', title: 'Poor Things', year: 2023, genre: ['Comedy', 'Drama', 'Fantasy'], rating: 4.4, reviewCount: 9870, poster: "https://images.unsplash.com/photo-1692127909148-d3ef513b1729", posterAlt: 'Vibrant surreal mountain and sky landscape', badge: 'staff-pick', runtime: 141 },
{ id: 'disc-004', title: 'Past Lives', year: 2023, genre: ['Drama', 'Romance'], rating: 4.7, reviewCount: 8910, poster: "https://images.unsplash.com/photo-1556809595-928653a20783", posterAlt: 'City lights at night with romantic blurred bokeh', badge: 'new', runtime: 106 },
{ id: 'disc-005', title: 'Spider-Man: Across the Spider-Verse', year: 2023, genre: ['Animation', 'Action'], rating: 4.9, reviewCount: 31450, poster: "https://img.rocket.new/generatedImages/rocket_gen_img_12495d3cd-1772301592545.png", posterAlt: 'Colorful cosmic space with vibrant colors', badge: 'top-rated', runtime: 140 },
{ id: 'disc-006', title: 'The Holdovers', year: 2023, genre: ['Drama', 'Comedy'], rating: 4.5, reviewCount: 7230, poster: "https://images.unsplash.com/photo-1671503796984-9f80f084a8be", posterAlt: 'Snow-covered buildings on quiet winter campus', runtime: 133 },
{ id: 'disc-007', title: 'All of Us Strangers', year: 2023, genre: ['Drama', 'Romance'], rating: 4.6, reviewCount: 5430, poster: "https://images.unsplash.com/photo-1706380764057-7eefd765c40a", posterAlt: 'Empty apartment corridor with moody soft lighting', runtime: 105 },
{ id: 'disc-008', title: 'Killers of the Flower Moon', year: 2023, genre: ['Drama', 'History', 'Crime'], rating: 4.5, reviewCount: 11240, poster: "https://images.unsplash.com/photo-1730828550968-3bd9456b58c2", posterAlt: 'Vast American plains landscape at golden hour', runtime: 206 },
{ id: 'disc-009', title: 'Saltburn', year: 2023, genre: ['Thriller', 'Drama'], rating: 4.1, reviewCount: 13670, poster: "https://images.unsplash.com/photo-1652179788009-4f5cafdfce9d", posterAlt: 'Dark gothic mansion surrounded by lush green grounds', badge: 'trending', runtime: 131 },
{ id: 'disc-010', title: 'Priscilla', year: 2023, genre: ['Drama', 'Biography'], rating: 4.0, reviewCount: 4560, poster: "https://images.unsplash.com/photo-1648451142763-6fb6244cb8a5", posterAlt: 'Retro aesthetic room with vintage decor and warm lighting', runtime: 113 },
{ id: 'disc-011', title: 'May December', year: 2023, genre: ['Drama', 'Comedy'], rating: 4.2, reviewCount: 3890, poster: "https://img.rocket.new/generatedImages/rocket_gen_img_1a6d7ec3f-1772140693587.png", posterAlt: 'Film projector light beam in dark cinema theater', badge: 'staff-pick', runtime: 117 },
{ id: 'disc-012', title: 'Dream Scenario', year: 2023, genre: ['Comedy', 'Fantasy'], rating: 3.9, reviewCount: 5120, poster: "https://images.unsplash.com/photo-1691911286605-3e07f912d0c4", posterAlt: 'Surreal dreamlike sky with clouds and light rays', runtime: 102 },
{ id: 'disc-013', title: 'Society of the Snow', year: 2024, genre: ['Drama', 'Survival'], rating: 4.6, reviewCount: 8730, poster: "https://img.rocket.new/generatedImages/rocket_gen_img_1124275b0-1777831636217.png", posterAlt: 'Snowy mountain landscape with dramatic white peaks', badge: 'new', runtime: 144 },
{ id: 'disc-014', title: 'Rebel Moon', year: 2023, genre: ['Sci-Fi', 'Action'], rating: 3.1, reviewCount: 7860, poster: "https://img.rocket.new/generatedImages/rocket_gen_img_11baf067f-1772170906388.png", posterAlt: 'Alien planet surface with multiple moons in dark sky', runtime: 134 },
{ id: 'disc-015', title: 'A Haunting in Venice', year: 2023, genre: ['Mystery', 'Horror'], rating: 3.8, reviewCount: 6540, poster: "https://images.unsplash.com/photo-1502180260176-8c7f7a73b54c", posterAlt: 'Foggy Venice canal at night with gothic architecture', runtime: 103 },
{ id: 'disc-016', title: 'The Beekeeper', year: 2024, genre: ['Action', 'Thriller'], rating: 3.7, reviewCount: 9230, poster: "https://images.unsplash.com/photo-1654521797259-a074509876a3", posterAlt: 'Golden honeycomb pattern with dramatic lighting', badge: 'new', runtime: 105 },
{ id: 'disc-017', title: 'Lisa Frankenstein', year: 2024, genre: ['Horror', 'Comedy', 'Romance'], rating: 3.4, reviewCount: 3210, poster: "https://images.unsplash.com/photo-1661239435163-778263516edc", posterAlt: 'Retro neon lights with pastel colors in night setting', runtime: 101 },
{ id: 'disc-018', title: 'Bob Marley: One Love', year: 2024, genre: ['Drama', 'Biography', 'Music'], rating: 3.9, reviewCount: 5670, poster: "https://images.unsplash.com/photo-1700227429707-d40f729b9325", posterAlt: 'Concert stage with colorful lights and crowd silhouettes', runtime: 107 },
{ id: 'disc-019', title: 'Argylle', year: 2024, genre: ['Action', 'Comedy', 'Spy'], rating: 3.2, reviewCount: 8140, poster: "https://img.rocket.new/generatedImages/rocket_gen_img_1424a5698-1766775492500.png", posterAlt: 'Colorful abstract spy thriller aesthetic with neon tones', runtime: 139 },
{ id: 'disc-020', title: 'Madame Web', year: 2024, genre: ['Action', 'Sci-Fi'], rating: 1.8, reviewCount: 4320, poster: "https://images.unsplash.com/photo-1533257498028-2eae5a1a29b9", posterAlt: 'Spider web pattern with blue light bokeh', runtime: 116 }];


const sortOptions = [
{ value: 'trending', label: 'Trending' },
{ value: 'rating', label: 'Highest Rated' },
{ value: 'newest', label: 'Newest First' },
{ value: 'most-reviewed', label: 'Most Reviewed' }];


export default function MovieDiscoveryGrid() {
  const [sortBy, setSortBy] = useState('trending');
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [page, setPage] = useState(1);
  const perPage = 12;

  const sorted = [...allMovies].sort((a, b) => {
    if (sortBy === 'rating') return b.rating - a.rating;
    if (sortBy === 'newest') return b.year - a.year;
    if (sortBy === 'most-reviewed') return b.reviewCount - a.reviewCount;
    return 0;
  });

  const paginated = sorted.slice(0, page * perPage);
  const hasMore = paginated.length < sorted.length;

  return (
    <section>
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2">
          <span className="w-1 h-5 bg-gold rounded-full" />
          <h2 className="text-lg font-700 text-foreground">All Movies</h2>
          <span className="text-sm text-muted-foreground ml-1">({allMovies.length} titles)</span>
        </div>
        <div className="flex items-center gap-2">
          {/* Sort */}
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="input-dark text-sm px-3 py-1.5 pr-8 appearance-none cursor-pointer">
            
            {sortOptions.map((opt) =>
            <option key={`sort-${opt.value}`} value={opt.value}>{opt.label}</option>
            )}
          </select>
          {/* View toggle */}
          <div className="flex items-center rounded-lg border border-border overflow-hidden">
            <button
              onClick={() => setViewMode('grid')}
              className={`p-2 transition-colors ${viewMode === 'grid' ? 'bg-muted text-foreground' : 'text-muted-foreground hover:text-foreground'}`}
              aria-label="Grid view">
              
              <Icon name="Squares2X2Icon" size={16} />
            </button>
            <button
              onClick={() => setViewMode('list')}
              className={`p-2 transition-colors ${viewMode === 'list' ? 'bg-muted text-foreground' : 'text-muted-foreground hover:text-foreground'}`}
              aria-label="List view">
              
              <Icon name="ListBulletIcon" size={16} />
            </button>
          </div>
        </div>
      </div>

      {viewMode === 'grid' ?
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-3 2xl:grid-cols-4 gap-5">
          {paginated.map((movie) =>
        <div key={movie.id} className="fade-in">
              <MovieCard movie={movie} size="md" />
            </div>
        )}
        </div> :

      <div className="space-y-2">
          {paginated.map((movie) =>
        <Link href="/movie-detail" key={movie.id}>
              <div className="flex items-center gap-4 p-3 rounded-xl bg-card border border-border hover:border-border/80 hover:bg-surface transition-all duration-150 group">
                <div className="relative w-14 h-20 rounded-lg overflow-hidden flex-shrink-0 bg-muted">
                  <AppImage src={movie.poster} alt={movie.posterAlt} fill className="object-cover" sizes="56px" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-600 text-foreground group-hover:text-accent transition-colors truncate">{movie.title}</h3>
                  <div className="flex items-center gap-2 mt-1 flex-wrap">
                    <span className="text-xs text-muted-foreground">{movie.year}</span>
                    <span className="text-xs text-muted-foreground">·</span>
                    <span className="text-xs text-muted-foreground">{movie.genre[0]}</span>
                    {movie.runtime &&
                <>
                        <span className="text-xs text-muted-foreground">·</span>
                        <span className="text-xs text-muted-foreground">{movie.runtime}m</span>
                      </>
                }
                  </div>
                </div>
                <div className="flex items-center gap-1.5 flex-shrink-0">
                  <Icon name="StarIcon" variant="solid" size={12} className="rating-star-filled" />
                  <span className="text-sm font-700 text-accent font-mono-nums">{movie.rating.toFixed(1)}</span>
                  <span className="text-xs text-muted-foreground hidden sm:block">({movie.reviewCount.toLocaleString()})</span>
                </div>
                {movie.badge &&
            <span className={`hidden sm:block px-2 py-0.5 rounded-md text-xs font-600 ${
            movie.badge === 'trending' ? 'badge-trending' :
            movie.badge === 'top-rated' ? 'bg-gold/15 text-gold border border-gold/25' :
            movie.badge === 'staff-pick' ? 'badge-staff-pick text-white' : 'badge-new text-white'}`
            }>
                    {movie.badge.replace('-', ' ')}
                  </span>
            }
              </div>
            </Link>
        )}
        </div>
      }

      {hasMore &&
      <div className="mt-8 text-center">
          <button
          onClick={() => setPage(page + 1)}
          className="btn-ghost px-8 py-3 rounded-xl text-sm font-600">
          
            Load More Movies
          </button>
        </div>
      }
    </section>);

}

import AppImage from '@/components/ui/AppImage';